import React, { useState } from "react";
import { MenuItem, InputLabel, Select, Box, Skeleton } from "@mui/material";

const InlineDropdown = ({
  label,
  labelId,
  options,
  selectedValue,
  placeholder,
  handleChange,
  dropdownWidth,
  size,
  dropdownId,
  disabled,
  isLoading,
}) => {
  const [isTouched, setIsTouched] = useState(false);

  const handleDropdownClick = () => {
    setIsTouched(true);
  };
  return (
    <>
      <InputLabel id={labelId}>{label}</InputLabel>

      {isLoading ? (
        <Box display="flex" alignItems="center" gap={2}>
          <Skeleton variant="rectangular" width={dropdownWidth} height={40} />
        </Box>
      ) : (
        <>
          <Select
            value={selectedValue}
            onChange={(event) => {
              const { value: newValue } = event.target;
              handleChange(newValue);
            }}
            onClick={handleDropdownClick}
            id={dropdownId}
            disabled={disabled}
            size={size ?? "small"}
            style={dropdownWidth ? { width: dropdownWidth } : undefined}
            {...(placeholder && {
              displayEmpty: true,
              renderValue: (selected) => {
                if (!selected) {
                  return <span style={{ color: "#aaa" }}>{placeholder}</span>;
                }
                const selectedOption = options?.find(
                  (opt) => opt.id === selected
                );
                return selectedOption?.name || null;
              },
            })}
          >
            {options?.map((item) => (
              <MenuItem key={item.id} value={item.id}>
                {item.name}
              </MenuItem>
            ))}
          </Select>
          <Box>
            {selectedValue === null && isTouched && (
              <span
                style={{ color: "red", fontSize: "12px", fontStyle: "italic" }}
              >
                {label} is required
              </span>
            )}
          </Box>
        </>
      )}
    </>
  );
};

export default InlineDropdown;
